import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography, { TypographyProps } from 'src/app/atoms/Typography/Typography';
import RevenueCalculatorResultsBlock, { RevenueCalculatorResultsBlockProps } from './RevenueCalculatorResultsBlock';
import RevenueCalculatorInputsBlock, { RevenueCalculatorInputsBlockProps } from './RevenueCalculatorInputsBlock';
import { cssVar } from 'src/app/styles/helper';

export interface RevenueCalculatorProps {
  resultsBlock: RevenueCalculatorResultsBlockProps;
  inputsBlock: RevenueCalculatorInputsBlockProps;
  orientation?: 'row' | 'column';
  helperText?: TypographyProps;
}

const RevenueCalculator = ({
  resultsBlock,
  inputsBlock,
  orientation = 'row',
  helperText,
}: RevenueCalculatorProps): JSX.Element => {
  const borderStyle = `1px solid ${cssVar('border-brand-alt')}`;
  const totalColumns = orientation === 'row' ? 2 : 1;

  return (
    <Stack
      direction='column'
      gap='spacing-xl'
    >
      <Grid
        totalColumns={totalColumns}
        totalColumnsLg={1}
        border={borderStyle}
        borderRadius='radius-2xl'
        overflow='hidden'
      >
        <RevenueCalculatorResultsBlock {...resultsBlock} />
        <RevenueCalculatorInputsBlock {...inputsBlock} />
      </Grid>
      {helperText && <Typography {...helperText} />}
    </Stack>
  );
};

export default RevenueCalculator;
